/**
 * OpenPositionBanner (web) — Annie Mode Phase 8 (PR #152).
 *
 * Renders an amber banner when the user is currently in MODE_A but has open
 * trade aggregates from MODE_B. Mirrors apps/mobile/src/components/OpenPositionBanner.tsx.
 */

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { tradingService } from '../services/trading';
import { useAuth } from '../contexts/AuthContext';
import { useModeTheme } from '../contexts/ModeThemeContext';

export function OpenPositionBanner() {
  const { user } = useAuth();
  const { mode: currentMode } = useModeTheme();

  const query = useQuery({
    queryKey: ['trade-aggregates', 'open'],
    queryFn: () => tradingService.getOpenAggregates(),
    enabled: !!user,
    staleTime: 15 * 1000,
  });

  const otherMode: 'ERIC' | 'ANNIE' = currentMode === 'ERIC' ? 'ANNIE' : 'ERIC';
  const otherCount = (query.data ?? []).filter(
    (agg) => agg.status === 'OPEN' && agg.algorithm === otherMode,
  ).length;

  if (otherCount === 0) return null;
  const otherName = otherMode === 'ERIC' ? 'Eric' : 'Annie';
  return (
    <div
      role="alert"
      className="px-4 py-3 rounded-xl flex items-center gap-2 mb-3"
      style={{ backgroundColor: '#FEF3C7', border: '1px solid #F59E0B' }}
    >
      <span style={{ color: '#92400E' }}>ℹ️</span>
      <span className="text-sm" style={{ color: '#78350F' }}>
        {otherCount === 1
          ? `1 position from ${otherName} is still being managed under ${otherName} rules.`
          : `${otherCount} positions from ${otherName} are still being managed under ${otherName} rules.`}
      </span>
    </div>
  );
}
